// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './components/HomePage';
import Branch1 from './stranky/Branch1';
import Branch2 from './stranky/Branch2';
import Branch3 from './stranky/Branch3';
import EditableMenu from './stranky/EditableMenu';
import EditMajitel from './stranky/EditMajitel';
import Login from './stranky/Login';
import PrintPage from './stranky/PrintPage';
import EditChot from './stranky/EditChot';
import EditHoly from './stranky/EditHoly';
import EditStan from './stranky/EditStan';

import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/branch1" element={<Branch1 />} />
        <Route path="/branch2" element={<Branch2 />} />
        <Route path="/branch3" element={<Branch3 />} />
        <Route path="/edit-menu" element={<EditableMenu />} />
        <Route path="/login" element={<Login />} />
        <Route path="/print" element={<PrintPage />} />
        <Route path="/majitel" element={<EditMajitel />} />
        <Route path="/editChot" element={<EditChot />} />
        <Route path="/editHoly" element={<EditHoly />} />
        <Route path="/editStan" element={<EditStan />} />
      </Routes>
    </Router>
  );
}

export default App;
